module.exports = __webpack_public_path__ + "static/media/innov_2.93255955.jpg";